import React, { useEffect } from 'react';
import { Instagram, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import siteConfig from '../config';

const InstagramFeed = () => {
  // Load Elfsight script
  useEffect(() => {
    // Check if script already exists
    if (!document.querySelector('script[src*="elfsightcdn.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
      
      script.onload = () => {
        console.log('Elfsight script loaded successfully');
      };
      
      script.onerror = () => {
        console.error('Failed to load Elfsight script');
      };
    }
  }, []);

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center space-x-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 via-pink-500 to-yellow-500 rounded-xl flex items-center justify-center">
              <Instagram className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Live from Instagram
            </h2>
          </div>
          <div className="h-1 w-24 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto mb-6"></div>
          <p className="text-gray-400 text-lg mb-6">
            See our latest work and daily updates from @motocraft.khanmarket
          </p>
        </div>

        {/* Elfsight Instagram Feed Widget */}
        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-8">
            <a 
              href={siteConfig.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button className="bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 hover:from-purple-600 hover:via-pink-600 hover:to-yellow-600 text-white font-bold text-lg px-8 py-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-purple-500/50 group">
                <Instagram className="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform" />
                Follow @motocraft.khanmarket
                <ExternalLink className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>

          {/* Live Instagram Feed (15+ Posts) */}
          <div className="instagram-feed-wrapper min-h-[400px]">
            <div className="elfsight-app-751590b1-06c7-4f34-9cf2-ca0839d36b44" data-elfsight-app-lazy></div>
          </div>
        </div>

        {/* Instagram Stats - Removed hardcoded numbers, live feed shows real data */}
      </div>
    </section>
  );
};

export default InstagramFeed;
